module.exports = __webpack_public_path__ + "./img-tseng_c25f95883ae65fd9f90ab35997413777.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/img-tseng.png
// module id = 432
// module chunks = 0